export const dataField = 'pricing.visual.nightlyLow';
